import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { FaBoxOpen, FaCartShopping, FaDumbbell } from 'react-icons/fa6';
import './ProductsPage.css';

const products = [
  {
    id: 'order-tracking',
    Icon: FaBoxOpen,
    title: 'Order Inventory Tracking',
    desc: 'End-to-end business management — create orders, manage inventory with low stock alerts, generate GST invoices & delivery challans, track customers, and run sales reports.',
    features: ['Orders with GST & invoice generation', 'Inventory with barcode scanning', 'Low stock alerts & threshold notifications', 'Customer management & order history', 'Sales reports & delivery challans'],
    link: '/products/order-tracking/login',
    status: 'live',
    color: '#5f217c',
  },
  {
    id: 'ecommerce',
    Icon: FaCartShopping,
    title: 'E-Commerce Integration',
    desc: 'Full-featured storefront management with product catalogues, cart management, checkout flows, and payment gateway integrations.',
    features: ['Product management', 'Cart & checkout', 'Payment gateways', 'Order fulfilment', 'Customer portal'],
    status: 'coming',
    color: '#c9a000',
  },
  {
    id: 'gym-app',
    Icon: FaDumbbell,
    title: 'Gym App',
    desc: 'Complete gym management software with member tracking, class scheduling, automated billing, and workout logging.',
    features: ['Member tracking', 'Class schedules', 'Automated billing', 'Workout logs', 'Member portal'],
    status: 'coming',
    color: '#2b1338',
  },
];

export default function ProductsPage() {
  return (
    <div className="products-page">
      <Helmet>
        <title>Order Management Software &amp; Business Tools for Small Businesses | EffyVenture</title>
        <meta name="description" content="Explore EffyVenture's order management software, inventory management system, and business tools. Order tracking, GST invoice generation, and sales reports for small businesses." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.effyventure.com/products" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.effyventure.com/products" />
        <meta property="og:site_name" content="EffyVenture" />
        <meta property="og:title" content="Order Management Software &amp; Business Tools for Small Businesses | EffyVenture" />
        <meta property="og:description" content="Explore EffyVenture's order management software and inventory management system. Free GST invoice generation, stock tracking, and sales reports for small businesses." />
        <meta property="og:image" content="https://www.effyventure.com/logo/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Order Management Software &amp; Business Tools for Small Businesses | EffyVenture" />
        <meta name="twitter:description" content="Order management software and inventory management system for small businesses. GST invoices, stock tracking, and sales reports." />
        <meta name="twitter:image" content="https://www.effyventure.com/logo/og-image.png" />
      </Helmet>
      <div className="products-page__hero">
        <div className="products-page__hero-content">
          <span className="eyebrow" style={{ justifyContent: 'center', marginBottom: 16 }}>The EffyVenture suite</span>
          <h1>Our Products</h1>
          <p>All the tools your business needs, continuously growing and improving.</p>
        </div>
      </div>

      <div className="products-page__grid">
        {products.map(p => (
          <div key={p.id} className={`product-card ${p.status === 'live' ? 'product-card--live' : ''}`} style={{ '--card-color': p.color }}>
            <div className="product-card__header">
              <span className="product-card__icon"><p.Icon /></span>
              <span className={`badge ${p.status === 'live' ? 'badge-completed' : 'badge-initiated'}`}>
                {p.status === 'live' ? '● Live' : 'Coming Soon'}
              </span>
            </div>
            <h2 className="product-card__title">{p.title}</h2>
            <p className="product-card__desc">{p.desc}</p>
            <ul className="product-card__features">
              {p.features.map((f, i) => (
                <li key={i}><span>✓</span> {f}</li>
              ))}
            </ul>
            {p.link ? (
              <Link to={p.link} className="btn btn-primary product-card__btn">
                Open App →
              </Link>
            ) : (
              <button className="btn btn-secondary product-card__btn" disabled>
                Coming Soon
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
